import { IFormState, ISelectedRegion, IOfferCalculatorSubmitPayload } from '../types/calculator';

/**
 * Собирает payload кастомного события: значения формы + `selectedRegion`.
 * В `regionId` (для потребителей события) — `parentId` гео-локации, если задан, иначе id выбранной локации.
 */
export function buildOfferCalculatorSubmitPayload(
  formValues: IFormState,
  selectedRegion: ISelectedRegion | null,
): IOfferCalculatorSubmitPayload {
  if (selectedRegion == null) {
    return { ...formValues, selectedRegion: null };
  }

  const eventRegionId =
    selectedRegion.parentId != null ? String(selectedRegion.parentId) : String(selectedRegion.regionId);

  return {
    ...formValues,
    regionId: eventRegionId,
    selectedRegion: { ...selectedRegion },
  };
}
